<div
  (click)="action()"
  id="priorityButton"
  class="priorityButton"
  [class.priorityButton__high]="ppPriority === 'HIGH'"
  [class.priorityButton__medium]="ppPriority === 'MEDIUM'"
  [class.priorityButton__low]="ppPriority === 'LOW'"
  [class.priorityButton--disabled]="ppDisabled"
  >
  <span id="buttonText" class="priorityButton__text">
    @if (ppProcessing) {
      <pp-spinner id="prioritySpinner"></pp-spinner>
    }
    @if (!ppProcessing) {
      <span id="priorityName">{{ priorityName }}</span>
    }
  </span>
</div>
